import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function Services() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative py-20 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/929a6e2199fb42dbfe26c9a349038447.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-green-900/80 to-blue-900/70"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Comprehensive <span className="text-yellow-300">Care</span>
            </h1>
            <p className="text-xl md:text-2xl max-w-3xl mx-auto leading-relaxed">
              Like the branches of a strong tree, our services extend in every direction to support your journey to stability and independence.
            </p>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Our Services</h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto">
              Evidence-based services rooted in Housing First, Harm Reduction, Motivational Interviewing, and Trauma-Informed care principles.
            </p>
          </div>
        </div>
      </section>

      {/* Case Management */}
      <section className="py-16 bg-emerald-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div 
              className="rounded-xl shadow-xl bg-cover bg-center h-96"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20case%20manager%20meeting%20with%20diverse%20client%20in%20comfortable%20office%20setting%2C%20supportive%20conversation%20and%20planning%20session%2C%20paperwork%20and%20resources%20on%20desk%2C%20caring%20and%20professional%20interaction%2C%20warm%20natural%20lighting%2C%20trust%20and%20collaboration%20atmosphere%2C%20inclusive%20service%20delivery&width=800&height=600&seq=case-management-service&orientation=portrait')`,
                backgroundPosition: 'center top'
              }}
            ></div>
            <div>
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-compass-3-line text-2xl text-white"></i>
                </div>
                <h3 className="text-3xl font-bold text-gray-900">Case Management</h3>
              </div>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Our experienced case managers provide individualized support and advocacy, helping navigate complex systems and coordinate comprehensive care.
              </p>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-emerald-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Strength-Based Assessment</h4>
                    <p className="text-gray-600">Comprehensive evaluation of strengths and needs</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-emerald-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Service Coordination</h4>
                    <p className="text-gray-600">Connecting to community resources and supports</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-emerald-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">System Navigation</h4>
                    <p className="text-gray-600">Advocacy and support through complex systems</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-emerald-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Crisis Support</h4>
                    <p className="text-gray-600">Immediate assistance during challenging times</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Employment Services */}
      <section className="py-16 bg-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-briefcase-line text-2xl text-white"></i>
                </div>
                <h3 className="text-3xl font-bold text-gray-900">Employment Services</h3>
              </div>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                We believe meaningful employment is key to long-term stability and independence. Our comprehensive employment services help individuals build careers, not just find jobs.
              </p>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-blue-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Career Assessment & Planning</h4>
                    <p className="text-gray-600">Identify strengths and career pathways</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-blue-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Skills Training & Education</h4>
                    <p className="text-gray-600">Vocational training and educational support</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-blue-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Job Placement & Support</h4>
                    <p className="text-gray-600">Direct placement with supportive employers</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-blue-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Entrepreneurship Support</h4>
                    <p className="text-gray-600">Resources for starting small businesses</p>
                  </div>
                </div>
              </div>
            </div>
            <div 
              className="rounded-xl shadow-xl bg-cover bg-center h-96"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Diverse%20group%20of%20people%20in%20job%20training%20workshop%2C%20professional%20skills%20development%20class%2C%20instructor%20helping%20students%20with%20various%20backgrounds%20and%20ages%2C%20modern%20training%20facility%2C%20hope%20and%20empowerment%20atmosphere%2C%20inclusive%20workplace%20learning%20environment%2C%20people%20of%20different%20ethnicities%20engaged%20in%20learning&width=800&height=600&seq=employment-service&orientation=portrait')`,
                backgroundPosition: 'center top'
              }}
            ></div>
          </div>
        </div>
      </section>

      {/* Mental Health Services */}
      <section className="py-16 bg-purple-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div 
              className="rounded-xl shadow-xl bg-cover bg-center h-96"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Peaceful%20therapy%20session%20with%20diverse%20therapist%20and%20client%20in%20comfortable%20counseling%20office%2C%20warm%20natural%20lighting%2C%20safe%20and%20supportive%20environment%2C%20trauma-informed%20care%20setting%2C%20healing%20and%20recovery%20atmosphere%2C%20professional%20mental%20health%20treatment%20space%2C%20inclusive%20therapeutic%20relationship&width=800&height=600&seq=mental-health-service&orientation=portrait')`,
                backgroundPosition: 'center top'
              }}
            ></div>
            <div>
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-heart-pulse-line text-2xl text-white"></i>
                </div>
                <h3 className="text-3xl font-bold text-gray-900">Mental Health & Therapy</h3>
              </div>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Our trauma-informed mental health services address the root causes of instability, providing healing and building resilience for lasting recovery.
              </p>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-purple-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Individual Therapy</h4>
                    <p className="text-gray-600">One-on-one counseling with licensed therapists</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-purple-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Group Therapy</h4>
                    <p className="text-gray-600">Peer support and shared healing experiences</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-purple-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Substance Use Support</h4>
                    <p className="text-gray-600">Harm reduction and recovery counseling</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-purple-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Crisis Intervention</h4>
                    <p className="text-gray-600">24/7 support during mental health crises</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Housing Services */}
      <section className="py-16 bg-orange-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-orange-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-home-heart-line text-2xl text-white"></i>
                </div>
                <h3 className="text-3xl font-bold text-gray-900">Housing Support</h3>
              </div>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Our Housing First approach provides immediate access to permanent housing without preconditions, because we believe stable housing is the foundation for all other recovery efforts.
              </p>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-orange-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Permanent Supportive Housing</h4>
                    <p className="text-gray-600">Long-term housing with wraparound services</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-orange-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Rental Assistance</h4>
                    <p className="text-gray-600">Financial support for housing stability</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-orange-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Housing Navigation</h4>
                    <p className="text-gray-600">Help finding and securing appropriate housing</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-orange-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Tenancy Support</h4>
                    <p className="text-gray-600">Skills and resources for maintaining housing</p>
                  </div>
                </div>
              </div>
            </div>
            <div 
              className="rounded-xl shadow-xl bg-cover bg-center h-96 order-1 lg:order-2"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20affordable%20housing%20complex%20with%20diverse%20residents%20including%20families%20and%20individuals%2C%20people%20of%20different%20ethnicities%20moving%20into%20new%20apartments%2C%20welcoming%20community%20atmosphere%2C%20green%20trees%20and%20landscaping%2C%20hope%20and%20new%20beginnings%20theme%2C%20professional%20architectural%20photography&width=800&height=600&seq=housing-service&orientation=portrait')`,
                backgroundPosition: 'center top'
              }}
            ></div>
          </div>
        </div>
      </section>

      {/* Evidence-Based Practices */}
      <section className="py-20 bg-gradient-to-br from-emerald-900 to-blue-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-6">Evidence-Based Practices</h2>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto">
              Our services are grounded in proven methodologies that have demonstrated success in supporting recovery and stability.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-home-heart-line text-3xl text-emerald-300"></i>
              </div>
              <h3 className="text-xl font-semibold mb-3">Housing First</h3>
              <p className="text-blue-100 text-sm leading-relaxed">
                Immediate permanent housing without preconditions as foundation for recovery
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-hand-heart-line text-3xl text-blue-300"></i>
              </div>
              <h3 className="text-xl font-semibold mb-3">Harm Reduction</h3>
              <p className="text-blue-100 text-sm leading-relaxed">
                Meeting people where they are and reducing risks associated with substance use
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-chat-heart-line text-3xl text-purple-300"></i>
              </div>
              <h3 className="text-xl font-semibold mb-3">Motivational Interviewing</h3>
              <p className="text-blue-100 text-sm leading-relaxed">
                Collaborative conversation style that strengthens motivation for positive change
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-3xl text-yellow-300"></i>
              </div>
              <h3 className="text-xl font-semibold mb-3">Trauma-Informed Care</h3>
              <p className="text-blue-100 text-sm leading-relaxed">
                Understanding and responding to the impact of traumatic stress on healing
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Ready to Get Started?</h2>
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
            Contact us today to learn more about our services or to begin your journey toward stability and independence.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="primary" size="lg">
              <i className="ri-phone-line mr-2"></i>
              Contact Us Today
            </Button>
            <Button variant="outline" size="lg">
              <i className="ri-download-line mr-2"></i>
              Download Brochure
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
